import { every, isArray, isString } from 'lodash';
export default function isValidDateParam(value) {
  // Ignore empty values
  if (!value) {
    return true;
  }
  // e.g. createdAt: ['>=...', '<=...']
  if (isArray(value)) {
    return every(value, isValidDateParam);
  }
  // The value should normally be a string
  // The only ops allowed are ">=" and "<="
  if (isString(value)) {
    return /^(>=|<=)/.test(value);
  }
  // Only arrays and strings are allowed
  return false;
}